import type { IPickerValue, IDateTypeOption } from '../types';

export const TYPES: IDateTypeOption[] = [
  {
    name: 'dbi_day',
    value: 'date',
  },
  {
    name: 'dbi_month',
    value: 'month',
  },
];

export const TYPES_PREFIXS_MAPPING: {
  [key: string]: string;
} = {
  date: 'D',
  month: 'M',
};

export const DEFAULT_VALUE_DAY: IPickerValue = {
  type: TYPES[0].value,
  value: ['1', '30'],
};

export const DEFAULT_VALUE_MONTH: IPickerValue = {
  type: TYPES[1].value,
  value: ['1', '6'],
};
